import { type Reducer } from '@reduxjs/toolkit'
import { type ComponentType, useLayoutEffect } from 'react'
import { useSelector, useStore } from 'react-redux'

import { type RootState, type SuiteStore } from '~/shell/redux/store'

/** The route module is cached by the router, but registration belongs to its Provider's store. */
export const RegisteredAppRoutes = ({
  appId,
  reducer,
  Component,
}: {
  appId: string
  reducer: Reducer
  Component: ComponentType
}) => {
  const store = useStore.withTypes<SuiteStore>()()
  const isRegistered = useSelector((state: RootState) =>
    Object.hasOwn(state, appId),
  )
  useLayoutEffect(() => {
    store.registerAppReducer(appId, reducer)
  }, [store, appId, reducer])
  return isRegistered ? <Component /> : null
}
